"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CdrBillingCategory = void 0;
var CdrBillingCategory;
(function (CdrBillingCategory) {
    CdrBillingCategory["NONE"] = "none";
    CdrBillingCategory["FREE"] = "free";
    CdrBillingCategory["DIRECTBILL_CALL"] = "directbill-call";
    CdrBillingCategory["DIRECTBILL_CALL_RELAY"] = "directbill-call-relay";
    CdrBillingCategory["CARD_ACCOUNT_CALL"] = "card-account-call";
    CdrBillingCategory["CARD_ACCOUNT_RELAY"] = "card-account-relay";
    CdrBillingCategory["WALLET_CALL"] = "wallet-call";
})(CdrBillingCategory = exports.CdrBillingCategory || (exports.CdrBillingCategory = {}));
(function (CdrBillingCategory) {
    function toFriendly(category, preferAbbreviated = true) {
        if (preferAbbreviated) {
            switch (category) {
                case CdrBillingCategory.CARD_ACCOUNT_CALL:
                case CdrBillingCategory.CARD_ACCOUNT_RELAY:
                    return 'Card';
                case CdrBillingCategory.DIRECTBILL_CALL:
                case CdrBillingCategory.DIRECTBILL_CALL_RELAY:
                    return 'Directbill';
                case CdrBillingCategory.WALLET_CALL:
                    return 'Wallet';
            }
        }
        // Replace dashes with spaces
        let friendly = (category || '').replace(/-/g, ' ');
        // Title case
        friendly = friendly
            .split(' ')
            .map((s) => s.charAt(0).toUpperCase() + s.substring(1))
            .join(' ');
        return friendly;
    }
    CdrBillingCategory.toFriendly = toFriendly;
})(CdrBillingCategory = exports.CdrBillingCategory || (exports.CdrBillingCategory = {}));
